import { useTranslation } from 'react-i18next'

import { RENTAL_PORTAL_VIEWING_STATUSES } from '../../../../constants/rentalPortal'
import { useDateLocale, useTimeZone } from '../../../../hooks'
import { EntityStatus } from '../../../Entity'
import Text from '../../../Text'
import { getViewingApplicantPreviewViewingLabel } from '../RentalPortalViewingApplicantPreviewModal.utils'

import * as styles from '../RentalPortalViewingApplicantPreviewModal.module.css'

function ViewingApplicantPreviewViewing({ viewing }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <div className={styles.rows}>
      <Text isSecondary className={styles.rowLabel}>
        {t('RentalPortal.ApplicantPreviewViewingLabelKey')}
      </Text>
      <Text className={styles.rowValue}>
        {getViewingApplicantPreviewViewingLabel({
          locale,
          t,
          timezone,
          viewing,
        })}
      </Text>
      <Text isSecondary className={styles.rowLabel}>
        {t('RentalPortal.ViewingStatusColumnKey')}
      </Text>
      <EntityStatus
        className={styles.rowStatus}
        id={viewing.status}
        statuses={RENTAL_PORTAL_VIEWING_STATUSES}
      />
    </div>
  )
}

export default ViewingApplicantPreviewViewing
